import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'abbreviateNumber',
    standalone: false
})
export class AbbreviateNumberPipe implements PipeTransform {
  // Overloads to allow both number and string inputs
  transform(value: number | undefined | null): string;
  transform(value: string | undefined | null): string;

  transform(num: number | string | undefined | null): string {
    if (num === null || num === undefined) {
      return '';
    }

    const numericValue =
      typeof num === 'number' ? num : parseFloat(num.replace(/[,_\s]/g, ''));

    if (isNaN(numericValue)) {
      return '';
    }

    if (Math.abs(numericValue) < 1000) {
      return numericValue.toString();
    }

    const units = ['K', 'M', 'B', 'T'];
    const power = Math.floor(Math.log10(Math.abs(numericValue)) / 3);
    const unit = units[power - 1] ?? '';

    let newValue = numericValue / Math.pow(10, power * 3);

    newValue = Number(
      Number.isInteger(newValue) ? newValue : newValue.toFixed(1),
    );

    return `${newValue}${unit}`;
  }
}
